import { render, staticRenderFns } from "./EventStatusBadge.vue?vue&type=template&id=e4b37a2c&"
import script from "./EventStatusBadge.vue?vue&type=script&lang=js&"
export * from "./EventStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports